import React from 'react';
import Markdown from 'markdown-to-jsx';
import { isAgentMessage, isUserMessage, Message } from './types';
import { LoaderIndeterminateCircular, Text } from '@stashinvest/react-components';
import { getLoading } from './utils';

type ChatMessageProps = {
	message: Message;
	index: number;
	length: number;
	loading: boolean;
};
export const ChatMessage = ({ message, index, length, loading }: ChatMessageProps) => {
	const isLoading = getLoading(message, length, index, loading);
	return (
		<>
			{isUserMessage(message) && (
				<div className="place-self-end cornerRadiusMedium bg-inverseContainer float-right py-contentXS px-contentSmall my-content3XS max-w-[300px]">
					<Text color="text-background" textStyle="bodySmallStandard" textAlign="right">
						{message.text}
					</Text>
				</div>
			)}
			{(isAgentMessage(message) || isLoading) && (
				<div className="place-self-start cornerRadiusMedium bg-container float-left py-contentXS px-contentSmall my-content3XS max-w-[300px]">
					{isLoading ? (
						<Text textStyle="bodySmallStandard" textAlign="left">
							{/*eslint-disable-next-line react/style-prop-object*/}
							<LoaderIndeterminateCircular size="medium" style="solid" />
						</Text>
					) : (
						<Text textStyle="bodySmallStandard" textAlign="left">
							<span style={{ whiteSpace: 'pre-wrap' }}>
								<Markdown options={{ forceBlock: true, forceInline: true }}>
									{message.text}
								</Markdown>
							</span>
						</Text>
					)}
				</div>
			)}
		</>
	);
};
